// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.8f74de164',
  revision: '8f74de164',
  branch: 'develop',
  date: 'Tue, 15 Sep 2026 16:18:57 GMT'
};